// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__t2Ozn","tl":"Container_tl__EXpeM","tr":"Container_tr__C_I5T","bl":"Container_bl__qFfN9","br":"Container_br__Ei0KF"};